var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.32,0A27.32,27.32,0,1,0,54.64,27.32,27.32,27.32,0,0,0,27.32,0ZM44.64,27.14a1.24,1.24,0,0,1,0,.51v.05l-.07.13a1.16,1.16,0,0,1-.26.39L31.14,41a1.25,1.25,0,0,1-.88.36,1.26,1.26,0,0,1-.87-2.16L40.32,28.58H11.24a1.26,1.26,0,0,1,0-2.52H40.32L29.39,15.42a1.26,1.26,0,1,1,1.75-1.8L44.37,26.51a1.08,1.08,0,0,1,.24.48l0,.15-.59.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.42e2ac532a56f3e5901d5ad32764eec7.svg";
export { ForwardRef as ReactComponent };